export const pageTitles = {
	jobs: 'Jobs',
	staff: 'Staff',
	feedback: 'Feedback',
	dashboard: 'Dashboard',
	reports: 'Reports',
	institutionSettings: 'Institution Settings',
	options: 'Options',
	systemSettings: 'System Settings',
	departmentList: 'DepartmentList',
	exportPreferences: 'Export Preferences',
	privacyPolicy: 'Privacy Policy',
	preferencesConfiguration: 'Preferences Configuration',
	productConfiguration: 'Product Configuration',
	managersList: 'Managers',
	jobMatchingPredictions: 'PredictionsList',
	rateEsclationConfiguration: 'RateEsclation Configuration',
	staffPersona: 'Staff Persona',
	staffPersonaMappings: 'StaffPersonaMappings',
	jobTemplates: 'Job Templates',
	skills: 'Skills',
	jobTemplateMappings: 'JobTemplateMappings',
	tags: 'Tags',
	trust: 'Trust',
	trustDetails: 'TrustDetails',
	trustList: 'TrustList',
	RightToWorkRequests: 'rightToWorkRequests',
	userList: 'userList',
	WeightAdjuster: 'weightAdjuster',
	ModelJobList: 'modelJobList',
	IncentiveList: 'incentiveList',
	Notification:'notificationSettings',
	StaffProfileConfiguration :'staffProfileConfiguration'
};
